var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcExcludeOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32.001C25.0605 32.001 32.0001 25.0614 32.0001 16.501C32.0001 7.94058 25.0605 1.00098 16.5 1.00098C7.9396 1.00098 1 7.94058 1 16.501C1 25.0614 7.9396 32.001 16.5 32.001Z",
    fill: "#13123A",
    stroke: "#EFEFEF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8535 18.1412L16.5 17.7876L16.1464 18.1412L11.5246 22.763C11.1761 23.1115 10.5864 23.1115 10.2379 22.763C9.88945 22.4145 9.88945 21.8248 10.2379 21.4764L14.8598 16.8545L15.2133 16.5009L14.8598 16.1474L10.2379 11.5255C9.88945 11.1771 9.88945 10.5874 10.2379 10.2389C10.5864 9.89042 11.1761 9.89042 11.5246 10.2389L16.1464 14.8607L16.5 15.2143L16.8535 14.8607L21.4754 10.2389C21.8238 9.89042 22.4136 9.89042 22.762 10.2389C23.1105 10.5874 23.1105 11.1771 22.762 11.5255L18.1402 16.1474L17.7866 16.5009L18.1402 16.8545L22.762 21.4764C23.1105 21.8248 23.1105 22.4145 22.762 22.763C22.4136 23.1115 21.8238 23.1115 21.4754 22.763L16.8535 18.1412Z",
    fill: "white",
    stroke: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExcludeOption);
export default __webpack_public_path__ + "static/media/ic_exclude_option.638a6c7ee681cb7552acf1274971b980.svg";
export { ForwardRef as ReactComponent };